import { EventBus, IReactiveModel, ViewModel } from '@descomplica/microfrontend-core';
import { action, computed, makeAutoObservable, observable } from 'mobx';

import { GetRolesCollaboration } from '@/modules/recognition/admin/application/collaborations/get-roles.collaboration';
import { GetUsersByScopeCollaboration } from '@/modules/recognition/admin/application/collaborations/get-users-by-scope.collaboration';
import {
  CreatedAccountEvent,
  CreateUserViewModel,
} from '@/modules/recognition/admin/presentation/screens/CreateUser.vm';
import type {
  AccountDto,
  ApplicationDto,
  RoleDto,
} from '@/shared/application/interfaces/pegasus-io.gateway';

import { GetApplicationCollaboration } from '../../application/collaborations/get-application.collaboration';

@ViewModel({ singleton: true })
export class ApplicationViewModel implements IReactiveModel {
  @observable application: ApplicationDto;
  @observable users: AccountDto[] = [];
  @observable roles: RoleDto[] = [];
  @observable isLoading = false;
  @observable hasError = false;
  @observable isLoadingRoles = false;
  @observable isSubmitting = false;

  constructor(
    private eventBus: EventBus,
    private getApplicationCollaboration: GetApplicationCollaboration,
    private getUsersByScope: GetUsersByScopeCollaboration,
    private getRolesCollaboration: GetRolesCollaboration,
    private createUserViewModel: CreateUserViewModel,
  ) {
    makeAutoObservable(this);

    this.eventBus.on(CreatedAccountEvent, this.handleCreatedUser.bind(this));
  }

  @action
  async onInit(props) {
    try {
      this.isLoading = true;

      const [{ data: application }, { data: users }, { data: roles }] = await Promise.all([
        this.getApplicationCollaboration.run(props.guid),
        this.getUsersByScope.run(props.guid),
        this.getRolesCollaboration.run(),
      ]);

      this.application = application;
      this.users = users;
      this.roles = roles;
    } catch (error) {
      console.error(error);
      this.hasError = true;
    } finally {
      this.isLoading = false;
    }
  }

  @action.bound
  handleCreatedUser(createdAccountEvent: CreatedAccountEvent) {
    this.users = [createdAccountEvent.user, ...this.users];
  }

  @action
  openCreateModal() {
    this.createUserViewModel.openCreateModal();
  }

  @action
  closeCreateModal() {
    this.createUserViewModel.closeCreateModal();
  }

  @computed
  get isCreateModalOpen() {
    return this.createUserViewModel.isCreateModalOpen;
  }
}
